/*======================================================================================================================
  * Bluebell: src/app/state/mind-maps/mind-maps.actions.ts
  * Last Edited: 11/08/2025
  * Copyright 2025 Bramble CFD LTD
  * The contents of this file are NOT for redistribution
  * See AUTHORS for list of developers on this project
 =====================================================================================================================*/
import { createAction, props } from '@ngrx/store';
import { MindMap, MindMapCreatePartial } from '@state/mind-maps/mind-maps.interfaces';


const name = (action: string) => `[Mind Maps] ${action}`;

// Create
export const createMindMap = createAction(
  name('Create Mind Map'),
  props<{mindMap: MindMapCreatePartial}>()
);
export const createMindMapSuccess = createAction(
  name('Create Mind Map Success'),
  props<{mindMap: MindMap}>()
);
export const createMindMapFailure = createAction(
  name('Create Mind Map Failure')
);

// Retrieve
export const loadMindMaps = createAction(
  name('Load Mind Maps'),
);
export const loadMindMapsSuccess = createAction(
  name('Load Mind Maps Success'),
  props<{mindMaps: MindMap[]}>()
);
export const loadMindMapsFailure = createAction(
  name('Load Mind Maps Failure'),
);

// Update
export const updateMindMap = createAction(
  name('Update Mind Map'),
  props<{project: string, uuid: string}>()
);
export const updateMindMapSuccess = createAction(
  name('Update Mind Map Success'),
  props<{mindMap: MindMap}>()
);
export const updateMindMapFailure = createAction(
  name('Update Mind Map Failure'),
);

// Save
export const saveMindMap = createAction(
  name('Save Mind Map'),
  props<{mindMap: MindMap}>()
);
export const saveMindMapSuccess = createAction(
  name('Save Mind Map Success'),
  props<{mindMap: MindMap}>()
);
export const saveMindMapFailure = createAction(
  name('Save Mind Map Failure'),
);

// Delete
export const deleteMindMap = createAction(
  name('Delete Mind Map'),
  props<{uuid: string}>()
);
export const deleteMindMapSuccess = createAction(
  name('Delete Mind Map Success'),
  props<{uuid: string}>()
);
export const deleteMindMapFailure = createAction(
  name('Delete Mind Map Failure'),
  props<{ error: string, status: number }>()
);

// Geometry
export const getGeometryPlot = createAction(
  name('Get Geometry Plot'),
  props<{uuid: string}>()
);

// Select
export const selectMindMap = createAction(
  name('Select Mind Map'),
  props<{uuid: string}>()
);
export const selectMindMapSuccess = createAction(
  name('Select Mind Map Success'),
  props<{mindMap: MindMap}>()
);
export const selectMindMapFailure = createAction(
  name('Select Mind Map Failure'),
);

// Clear
export const clearMindMap = createAction(
  name('Clear Mind Map'),
);
